import * as Yup from 'yup'

export const CreateTagSchema = Yup.object().shape({
  name: Yup.string().required(`Tag name is required`).max(90, 'The maximum length allowed is 90'),
  description: Yup.string(),
})
